import { useQuery } from '@tanstack/react-query';

import { PayStationMonitoringStatus } from 'src/features/monitoring/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/monitoring/pay-station/:payStationId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    payStationId: string;
}
const queryFn = ({ parkingId, payStationId }: DTO): Promise<PayStationMonitoringStatus> => {
    return axios.get(formatResourcePath(RESOURCE, { payStationId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload.payStationId],
        queryFn: async () => await queryFn(payload),
        // PAY_STATION_* WS events invalidate this query on real changes; the
        // stale window covers reconnects and avoids per-mount refetches.
        staleTime: 5 * 60 * 1000,
        ...config,
    });

export { useQueryHook as useGetPayStationStatus, RESOURCE as GET_PAY_STATION_STATUS_RESOURCE };
